export class LocationSelectorComponent {
 static config = {
  selector: 'afLocationSelector',
  controller: LocationSelectorComponent,
  bindings: {
      isLoading: '<',
      onSelectChange: '&',
  },
  template: `
            <md-menu ng-if="!$ctrl.isLoading" class="mw-menu" md-position-mode="target-left target" md-offset="0 50">
                <mw-menu-trigger-button tooltip="{{'Open Menu' | translate}}" on-click="$mdMenu.open($event)">
                    <span translate>{{ $ctrl.selectItems[$ctrl.selectedKey] }}</span>
                </mw-menu-trigger-button>

                <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
                    <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
                    <mw-menu-item 
                        ng-repeat="(key, value) in $ctrl.selectItems track by key"
                        type="singleselect" 
                        is-selected="$ctrl.selectedKey == key" 
                        on-click="$ctrl.handleSelection(key)">
                            <span translate>{{ value }}</span>
                    </mw-menu-item>
                </md-menu-content>
            </md-menu>
        `,
 }

 private selectedKey: string;
 private onSelectChange: any;
 private selectItems = {
     countries: 'Country',
     states: 'State / Province',
     cities: 'City'
 };

 $onInit() {
     this.selectedKey = Object.keys(this.selectItems)[0];
     this.onSelectChange({location: this.selectedKey});
 }

 handleSelection(key: any) {
     this.selectedKey = key;
     this.onSelectChange({location: this.selectedKey});
 }
}
